<script lang="ts">
	import NavigationLoction from '@icons/NavigationLoction.svelte';
	import Icon from './Icon.svelte';
	import ContentClock from '@icons/ContentClock.svelte';
	import Button from '@components/Button.svelte';
	import Link from './Link.svelte';
	import { format } from 'date-fns';
	import { de } from 'date-fns/locale';
	import { createEventDispatcher } from 'svelte';
	import { EventSlotStatus } from '$lib/eventSlotStatus';
	import SlotTicketStatus from './SlotTicketStatus.svelte';
	import { getMapsLocationLink } from '$lib/geo';
	import { fly } from 'svelte/transition';

	export let startsAt: Date;
	export let endsAt: Date;
	export let registrationDeadline: Date;
	export let location: string = '';
	export let slotId: string;
	export let status: EventSlotStatus;
	export let isParticipation = false;
	let className = '';
	export { className as class };

	const dispatch = createEventDispatcher<{
		action: {
			slotId: string;
		};
	}>();

	function handleAction() {
		dispatch('action', { slotId });
	}
</script>

<div
	class="bg-white rounded-[9px] p-2.25 lg:pr-6 flex flex-col lg:flex-row lg:items-center lg:gap-9 {className}"
	class:!bg-gray-11={status === EventSlotStatus.Cancelled}
	class:pointer-events-none={status === EventSlotStatus.Cancelled}
	in:fly
>
	<div
		class="flex flex-col gap-1 md:flex-row md:gap-6 md:items-center mb-0 md:mb-3 lg:mb-0"
		class:opacity-50={status === EventSlotStatus.Cancelled}
	>
		<div
			class="w-28 bg-gray-11 rounded p-3 font-bold flex flex-col text-center justify-center"
			class:!bg-gray-10={status === EventSlotStatus.Cancelled}
		>
			<span class="text-quaternary">{format(startsAt, 'dd.MM.')}</span>
			<span class="text-additional"
				>{format(startsAt, 'EEEE', {
					locale: de
				})}</span
			>
		</div>

		<div class="flex flex-col gap-2 py-2 lg:py-0 flex-grow lg:min-w-64 lg:max-w-64">
			<div class="flex gap-2 text-additional">
				<Icon
					component={ContentClock}
					aria-label="Zeit des Events"
					class="!w-4 !h-4 mr-1.5"
				/>{format(startsAt, 'HH:mm')} – {format(endsAt, 'HH:mm')}
				Uhr
			</div>
			<div class="flex gap-2 text-additional">
				<Icon component={NavigationLoction} class="!w-4 !h-4 mr-1.5" aria-label="Ort" /><Link
					tag="a"
					href={getMapsLocationLink(location)}
					rel="noreferrer noopener"
					target="_blank"
					class="!text-additional"
					tabindex={status === EventSlotStatus.Cancelled ? -1 : 0}
				>
					{location}</Link
				>
			</div>
		</div>
	</div>

	<!--
		in /profile route this is a participation rather than a normal slot that still can be booked  
		therefore omit the status expect for cancelled slots
	-->
	{#if !isParticipation || status === EventSlotStatus.Cancelled}
		<SlotTicketStatus {registrationDeadline} {status} />
	{/if}

	<slot name="action">
		{#if !isParticipation}
			{#if status === EventSlotStatus.Open || status === EventSlotStatus.AlmostFull}
				<Button
					on:click={handleAction}
					class="w-full lg:w-[12.5rem] ml-auto"
					trackingLabel="Zur Buchung">Zur Buchung</Button
				>
			{/if}

			{#if status === EventSlotStatus.Full}
				<Button
					variant="secondary"
					on:click={handleAction}
					class="w-full lg:w-[12.5rem] ml-auto"
					trackingLabel="Auf Warteliste setzen"
				>
					Auf Warteliste setzen
				</Button>
			{/if}
		{/if}
	</slot>
</div>
